import useApiWorker from 'hooks/useApiWorker';
import { Job, JobIdentifier } from '../types/job';

export async function ListJobs(): Promise<ApiListResponse<JobIdentifier>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get<Array<JobIdentifier>>(`/Jobs`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      if (error?.response?.data?.message) {
        return {
          success: false,
          message: error.response.data.message,
        };
      } else {
        return {
          success: false,
          message: 'Error getting jobs.',
        };
      }
    });
}

export async function GetJob(jobName: string): Promise<ApiResponse<Job>> {
  const apiWorker = useApiWorker();
  return apiWorker
    .get<Job>(`/jobs/${jobName}`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return { success: false, message: error.response.data.message };
    });
}

export async function AddJob(job: Job): Promise<ApiResponse<Job>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .post<Job>(`/jobs`, job)
    .then(() => {
      return { success: true, job };
    })
    .catch((error) => {
      console.log(error)
      return {
        job,
        errors: error.response.data,
        message: error.response.data.Rules != undefined ? error.response.data.Rules[0] : 'An error ocurred while adding rules to the new Job. Make sure any Variables used in a Group of Rules are set for the the job.',
        success: false,
      };
    });
}

export async function UpdateJob(jobName: string, job: Job): Promise<ApiResponse<Job>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .put<Job>(`/jobs/${jobName}`, job)
    .then(() => {
      return { success: true, job };
    })
    .catch((error) => {
      return {
        job,
        errors: error.response.data,
        message: error.response.data.Rules != undefined ? error.response.data.Rules[0] : 'An error ocurred',
        success: false,
      };
    });
}

export async function DeleteJob(job: Job): Promise<ApiResponse<Job>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .delete(`/jobs/${job.Name}`)
    .then(() => {
      return { success: true, job };
    })
    .catch((error) => {
      return { success: false, message: error.response.data };
    });
}

export async function GetCurrentSchoolYear(): Promise<ApiResponse<string>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get<string>(`/jobs/currentSchoolYear`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return { success: false, message: error.response.data };
    });
}
